const $ = jQuery.noConflict();

const hero = () => {
	// Cache DOM
	const heroList = $('.hero__list-container');

	// Functions
	function setHeight() {
		const options = {
			byRow: false,
		};
		heroList.find('.hero__list-item-title').matchHeight(options);
		heroList.find('.hero__list-item-text').matchHeight(options);
	}

	if (heroList.length) {
		setHeight();
	}
};

export default hero;
